export default "__VITE_ASSET__D05qUUMg__"